export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";